import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { axiosErrorHandler } from 'common/helpers/axios.helper';
import { AppDispatch, RootState } from 'app/store';
import {
  IBuyerCityListParams,
  IDelivery,
  // // TODO FIX after api package is updated
  // ICreateDeliveryPayload,
  // IDeleteDeliveryPayload,
  IDeliveryListParams,
  // IUpdateDeliveryPayload,
} from 'entities/Delivery/Delivery.models';
import { deliveryTransport } from 'entities/Delivery/Delivery.transport';

interface IState {
  deliveryList: IDelivery[];
  isDeliveryLoading: boolean;
  deliveryBuyerCities: string[];
}

const initialState: IState = {
  deliveryList: [],
  isDeliveryLoading: false,
  deliveryBuyerCities: [],
};

export const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    setDeliveryList(state, action: PayloadAction<IDelivery[]>) {
      state.deliveryList = action.payload;
    },
    setIsDeliveryLoading(state, action: PayloadAction<boolean>) {
      state.isDeliveryLoading = action.payload;
    },
    setDeliveryBuyerCities(state, action: PayloadAction<string[]>) {
      state.deliveryBuyerCities = action.payload;
    },
    addDeliveryListItem(state, action: PayloadAction<IDelivery>) {
      state.deliveryList.push(action.payload);
    },
    patchDeliveryListItem(state, action: PayloadAction<IDelivery>) {
      const delivery = state.deliveryList.find(
        (item) =>
          item.contractId === action.payload.contractId &&
          item.stockId === action.payload.stockId &&
          item.city === action.payload.city,
      );

      if (!delivery) {
        return;
      }

      Object.assign(delivery, action.payload);
    },
    removeDeliveryListItem(state, action: PayloadAction<IDelivery>) {
      state.deliveryList = state.deliveryList.filter(
        (item) =>
          !(
            item.contractId === action.payload.contractId &&
            item.stockId === action.payload.stockId &&
            item.city === action.payload.city
          ),
      );
    },
  },
});

export const {
  setDeliveryList,
  setIsDeliveryLoading,
  setDeliveryBuyerCities,
  addDeliveryListItem,
  patchDeliveryListItem,
  removeDeliveryListItem,
} = deliverySlice.actions;

export const selectDeliveryList = (state: RootState) => state.delivery.deliveryList;
export const selectIsDeliveryLoading = (state: RootState) => state.delivery.isDeliveryLoading;
export const selectDeliveryBuyerCities = (state: RootState) => state.delivery.deliveryBuyerCities;

export const deliveryReducer = deliverySlice.reducer;

export const getDeliveryList = (params: IDeliveryListParams) => async (dispatch: AppDispatch) => {
  dispatch(setIsDeliveryLoading(true));

  try {
    const response = await deliveryTransport.get(params);
    dispatch(setDeliveryList(response.data));
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsDeliveryLoading(false));
  }
};
// TODO FIX after api package is updated
export const createDelivery = (payload: any) => async (dispatch: AppDispatch) => {
  dispatch(setIsDeliveryLoading(true));

  try {
    const response = await deliveryTransport.create(payload);
    dispatch(addDeliveryListItem(response));
    payload.onSuccess?.();
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsDeliveryLoading(false));
  }
};

export const updateDelivery = (payload: any) => async (dispatch: AppDispatch) => {
  dispatch(setIsDeliveryLoading(true));

  try {
    const response = await deliveryTransport.update(payload);
    dispatch(patchDeliveryListItem(response));
    payload.onSuccess?.();
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsDeliveryLoading(false));
  }
};

export const deleteDelivery = (payload: any) => async (dispatch: AppDispatch) => {
  dispatch(setIsDeliveryLoading(true));

  try {
    const response = await deliveryTransport.delete(payload);
    dispatch(removeDeliveryListItem(response));
    payload.onSuccess?.();
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsDeliveryLoading(false));
  }
};

export const getDeliveryBuyerCities = (params: IBuyerCityListParams) => async (dispatch: AppDispatch) => {
  dispatch(setIsDeliveryLoading(true));

  try {
    const response = await deliveryTransport.getBuyerCities(params);
    dispatch(setDeliveryBuyerCities(response.data));
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsDeliveryLoading(false));
  }
};
